module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/zoom-f457e59a9c0b9e863b2e19b433ce84db.svg";